import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { appSubscriptionWizardConfig } from './app/app-subscription-wizard.config';
import { AppSubscriptionWizardComponent } from './app/app-subscription-wizard.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppSubscriptionWizardComponent, {
  ...appSubscriptionWizardConfig,
  providers: [provideZoneChangeDetection(), ...appSubscriptionWizardConfig.providers],
}).catch(err => console.error(err));
